import React, { useState, useEffect } from 'react'
import apiFetch from '@utils/apiFetch'

export default function Contact() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState(null)
  const [error, setError] = useState('')
  // Predefined support topics
  const commonSubjects = [
    "I can't log in to my account",
    "Need help submitting or editing an event",
    "Question about event approval status",
    "Issue broadcasting my event to displays",
    "Billing or payment inquiry",
    "Scheduling or managing a display installation",
    "Content not updating on my display",
    "Other (please specify below)",
  ]

  // Auto-fill user info if authenticated
  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) return
    apiFetch('/api/auth/me')
      .then((res) => {
        if (!res.ok) throw new Error('Not authenticated')
        return res.json()
      })
      .then((data) => {
        if (data.firstName || data.lastName) {
          setName(`${data.firstName || ''} ${data.lastName || ''}`.trim())
        }
        if (data.email) {
          setEmail(data.email)
        }
      })
      .catch(() => {
        // ignore if not logged in
      })
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setStatus(null)
    setError('')
    if (!email || !subject || !message) {
      setError('Email, subject, and message are required.')
      return
    }
    try {
      const res = await apiFetch('/api/support/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, subject, message }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Failed to send message')
      setStatus('success')
      setName('')
      setEmail('')
      setSubject('')
      setMessage('')
    } catch (err) {
      setStatus('error')
      setError(err.message)
    }
  }

  return (
    <div className="p-4 max-w-lg mx-auto">
      <h1 className="text-2xl font-bold mb-4">Contact Support</h1>
      {status === 'success' && (
        <p className="text-success mb-4">Your message has been sent. We will get back to you soon.</p>
      )}
      {status === 'error' && <p className="text-error mb-4">Error: {error}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1 font-medium">Name (optional)</label>
          <input
            type="text"
            className="border p-2 w-full"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div>
          <label className="block mb-1 font-medium">Email *</label>
          <input
            type="email"
            className="border p-2 w-full"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        {/* Topic Dropdown */}
        <div>
          <label className="block mb-1 font-medium">Topic (optional)</label>
          <select
            className="border p-2 w-full mb-2"
            value={commonSubjects.includes(subject) ? subject : ''}
            onChange={(e) => setSubject(e.target.value)}
          >
            <option value="">-- Select a topic --</option>
            {commonSubjects.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
        {/* Subject Input */}
        <div>
          <label className="block mb-1 font-medium">Subject *</label>
          <input
            type="text"
            className="border p-2 w-full"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block mb-1 font-medium">Message *</label>
          <textarea
            className="border p-2 w-full h-32"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="px-4 py-2 bg-primary text-white rounded hover:bg-primary-hover"
        >
          Send
        </button>
      </form>
    </div>
  )
}